/**
 * ipcConstants.js
 * Talkroute
 *
 * Created by Vel Genov on 1/30/19
 * Copyright (c) 2019 Talkroute. All right reserved.
 */

/**
 * Constants for the IPC messages
 */
const ipcConstants = {
  // A request to show window
  CLICK_NOTIFICATION: "CLICK_NOTIFICATION",
  // A request to show the preferences menu
  SHOW_PREFERENCES: "SHOW_PREFERENCES",
  // The user requesting an update to the app
  REQUEST_UPDATE: "REQUEST_UPDATE",
  // A request to start autoupdater
  START_AUTOUPDATER: "START_AUTOUPDATER",
  // Auto updater checked for updated
  CHECKED_FOR_UPDATES: "CHECKED_FOR_UPDATES",
  // A request to update the badge number for Windows
  UPDATE_BADGE_WIN: "update-badge",
  // A request to update the badge number for Mac, Linux
  UPDATE_BADGE_MAC_LINUX: "update-badge-mac-linux",
  // The window is shown after hidden
  SHOW_WINDOW: "SHOW_WINDOW",
  // User was redirected from the browser using tel: link
  TEL_LINK_CALL: "TEL_LINK_CALL",
  OPEN_INCOMING_CALL_NOTIFICATION: "OPEN_INCOMING_CALL_NOTIFICATION",
  CLOSE_INCOMING_CALL_NOTIFICATION: "CLOSE_INCOMING_CALL_NOTIFICATION",
  OPEN_RECONNECTING_NOTIFICATION: "OPEN_RECONNECTING_NOTIFICATION",
  CLOSE_RECONNECTING_NOTIFICATION: "CLOSE_RECONNECTING_NOTIFICATION",
  OPEN_CONNECTION_LOST_NOTIFICATION: "OPEN_CONNECTION_LOST_NOTIFICATION",
  CLOSE_CONNECTION_LOST_NOTIFICATION: "CLOSE_CONNECTION_LOST_NOTIFICATION",
  OPEN_CONNECTED_NOTIFICATION: "OPEN_CONNECTED_NOTIFICATION"
};

export default ipcConstants;
